// TypingEffect.js
import React, { useEffect, useRef } from 'react';
import Typed from 'typed.js';

const TypingEffect = () => {
  const el = useRef(null);
  const typed = useRef(null);

  useEffect(() => {
    typed.current = new Typed(el.current, {
      strings: ['Quality', 'Excellence', 'Integrity', 'Innovation'],
      typeSpeed: 50,
      backSpeed: 30,
      loop: true,
    });

    return () => {
      // Destroy Typed instance on unmounting
      typed.current.destroy();
    };
  }, []);

  return (
    <span>
      <span ref={el}></span>
    </span>
  );
};

export default TypingEffect;
